import { Collection } from './Collection';
import { $ } from './Framework';
function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1)
        return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
}
const Helpers = {
    ready: function () {
        return new Promise((resolve) => {
            if (document.readyState != 'loading') {
                resolve();
            }
            else {
                $(document).on('DOMContentLoaded', function () {
                    resolve();
                });
            }
        });
    },
    imagesLoaded: function () {
        return new Promise((resolve) => {
            var images = $('img');
            var imagesLoaded = 0;
            function countLoadedImage() {
                if (++imagesLoaded == images.length)
                    resolve();
            }
            images.forEach((image) => {
                if (image.complete) {
                    countLoadedImage();
                }
                else {
                    $(image).on(['load', 'error'], countLoadedImage);
                }
            });
            if (images.length == 0)
                resolve();
        });
    },
    scrollTo: function (to, duration = 500, item = null) {
        var start = (item) ? item.scrollTop : window.pageYOffset;
        var change = to - start;
        var currentTime = 0;
        var increment = 15;
        var target = (item) ? item : window;
        var animateScroll = function () {
            currentTime += increment;
            target.scrollTo(0, easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration)
                setTimeout(animateScroll, increment);
        };
        animateScroll();
    },
    parseHTML: function (html) {
        var tempDocument = document.implementation.createHTMLDocument();
        tempDocument.body.innerHTML = html;
        return new Collection(tempDocument.body.children);
    }
};
export function addHelpers(base) {
    return Object.assign(base, Helpers);
}
